// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3QnFX","containerItemsCenter":"Skeleton_containerItemsCenter__3LHm3"};